"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = Header;
const react_1 = __importDefault(require("react"));
const use_optimized_image_1 = __importDefault(require("~/helpers/use-optimized-image"));
const Link_1 = require("../../../pages/flex-page/components/Link");
require("./header.scss");
function Header({ links }) {
    const riceLogo = (0, use_optimized_image_1.default)('https://openstax.org/dist/images/rice.webp', 150);
    return (react_1.default.createElement("div", { className: "container", "data-analytics-label": "Header" },
        react_1.default.createElement("menu", { "data-analytics-nav": "Landing Menu" },
            react_1.default.createElement("li", null,
                react_1.default.createElement("a", { href: "/", "aria-label": "Home Page", "data-analytics-link": true },
                    react_1.default.createElement("img", { src: "/dist/images/logo.svg", alt: "OpenStax logo", width: "354", height: "81" }))),
            react_1.default.createElement("li", null,
                react_1.default.createElement("a", { href: "http://www.rice.edu" },
                    react_1.default.createElement("img", { src: riceLogo, alt: "Rice University logo", height: "57", width: "150" })))),
        react_1.default.createElement("menu", { "data-analytics-nav": "Landing Menu" },
            links.map((link, i) => react_1.default.createElement("li", { key: i },
                react_1.default.createElement(Link_1.Link, { link: link }))),
            react_1.default.createElement("li", null,
                react_1.default.createElement("a", { href: "/give", className: "give-button", "data-analytics-link": true }, "Give")))));
}
